var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGooglePlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 40,
    viewBox: "0 0 135 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M130 40H5C2.25 40 0 37.75 0 35V5C0 2.25 2.25 0 5 0H130C132.75 0 135 2.25 135 5V35C135 37.75 132.75 40 130 40Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M130 0.8C132.32 0.8 134.2 2.68 134.2 5V35C134.2 37.32 132.32 39.2 130 39.2H5C2.68 39.2 0.799999 37.32 0.799999 35V5C0.799999 2.68 2.68 0.8 5 0.8H130ZM130 0H5C2.25 0 0 2.25 0 5V35C0 37.75 2.25 40 5 40H130C132.75 40 135 37.75 135 35V5C135 2.25 132.75 0 130 0Z",
    fill: "#A6A6A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7203 12.7899C62.6603 12.7899 60.9903 14.3499 60.9903 16.5099C60.9903 18.6499 62.6703 20.2299 64.7203 20.2299C66.7803 20.2299 68.4503 18.6499 68.4503 16.5099C68.4503 14.3499 66.7803 12.7899 64.7203 12.7899ZM64.7203 18.7599C63.5903 18.7599 62.6203 17.8299 62.6203 16.5099C62.6203 15.1699 63.5903 14.2599 64.7203 14.2599C65.8503 14.2599 66.8203 15.1799 66.8203 16.5099C66.8203 17.8299 65.8503 18.7599 64.7203 18.7599ZM56.5803 12.7899C54.5203 12.7899 52.8503 14.3499 52.8503 16.5099C52.8503 18.6499 54.5303 20.2299 56.5803 20.2299C58.6303 20.2299 60.3103 18.6499 60.3103 16.5099C60.3103 14.3499 58.6403 12.7899 56.5803 12.7899ZM56.5803 18.7599C55.4503 18.7599 54.4803 17.8299 54.4803 16.5099C54.4803 15.1699 55.4503 14.2599 56.5803 14.2599C57.7103 14.2599 58.6803 15.1799 58.6803 16.5099C58.6803 17.8299 57.7103 18.7599 56.5803 18.7599ZM46.9003 13.9299V15.5099H50.6703C50.5603 16.3999 50.2603 17.0399 49.8103 17.4999C49.2603 18.0499 48.4003 18.6499 46.9003 18.6499C44.5803 18.6499 42.7603 16.7799 42.7603 14.4499C42.7603 12.1199 44.5803 10.2499 46.9003 10.2499C48.1503 10.2499 49.0703 10.7399 49.7403 11.3799L50.8503 10.2699C49.9103 9.36993 48.6503 8.67993 46.8903 8.67993C43.7103 8.67993 41.0303 11.2699 41.0303 14.4499C41.0303 17.6299 43.7103 20.2199 46.8903 20.2199C48.6103 20.2199 49.9003 19.6599 50.9203 18.5999C51.9603 17.5599 52.2903 16.0899 52.2903 14.9099C52.2903 14.5399 52.2603 14.2099 52.2103 13.9199H46.9003V13.9299ZM86.5003 15.1499C86.1903 14.3199 85.2503 12.7799 83.3203 12.7799C81.4003 12.7799 79.8103 14.2899 79.8103 16.4999C79.8103 18.5799 81.3903 20.2199 83.5003 20.2199C85.2003 20.2199 86.1903 19.1799 86.6003 18.5699L85.3303 17.7299C84.9103 18.3499 84.3303 18.7599 83.5003 18.7599C82.6703 18.7599 82.0803 18.3799 81.7003 17.6299L86.6703 15.5699L86.5003 15.1499ZM81.4303 16.3899C81.3903 14.9499 82.5403 14.2199 83.3703 14.2199C84.0203 14.2199 84.5703 14.5399 84.7503 15.0099L81.4303 16.3899ZM77.3903 19.9999H79.0203V9.06993H77.3903V19.9999ZM74.7103 13.6199H74.6503C74.2803 13.1799 73.5803 12.7899 72.6903 12.7899C70.8303 12.7899 69.1303 14.4199 69.1303 16.5199C69.1303 18.5999 70.8303 20.2199 72.6903 20.2199C73.5803 20.2199 74.2803 19.8299 74.6503 19.3799H74.7103V19.9199C74.7103 21.3399 73.9503 22.0999 72.7203 22.0999C71.7203 22.0999 71.1003 21.3799 70.8503 20.7799L69.4303 21.3699C69.8403 22.3599 70.9203 23.5699 72.7303 23.5699C74.6503 23.5699 76.2603 22.4399 76.2603 19.6999V13.0299H74.7103V13.6199ZM72.8403 18.7599C71.7103 18.7599 70.7703 17.8199 70.7703 16.5199C70.7703 15.2099 71.7103 14.2499 72.8403 14.2499C73.9503 14.2499 74.8303 15.2099 74.8303 16.5199C74.8303 17.8099 73.9503 18.7599 72.8403 18.7599ZM94.1503 9.06993H90.2403V19.9999H91.8703V15.8599H94.1503C95.9603 15.8599 97.7303 14.5499 97.7303 12.4699C97.7303 10.3899 95.9603 9.06993 94.1503 9.06993ZM94.1903 14.3299H91.8703V10.5799H94.1903C95.4103 10.5799 96.1003 11.5899 96.1003 12.4499C96.1103 13.3099 95.4103 14.3299 94.1903 14.3299ZM104.27 12.7699C103.09 12.7699 101.87 13.2899 101.36 14.4399L102.81 15.0399C103.12 14.4399 103.7 14.2399 104.3 14.2399C105.14 14.2399 106 14.7499 106.02 15.6499V15.7599C105.72 15.5899 105.09 15.3399 104.32 15.3399C102.76 15.3399 101.17 16.1999 101.17 17.7999C101.17 19.2599 102.45 20.1999 103.88 20.1999C104.98 20.1999 105.58 19.7099 105.96 19.1299H106.02V19.9699H107.59V15.7799C107.59 13.8499 106.14 12.7699 104.27 12.7699ZM104.08 18.7499C103.55 18.7499 102.8 18.4799 102.8 17.8199C102.8 16.9799 103.73 16.6499 104.53 16.6499C105.25 16.6499 105.58 16.7999 106.02 17.0199C105.89 18.0399 105.02 18.7499 104.08 18.7499ZM113.33 12.9999L111.46 17.7399H111.4L109.46 12.9999H107.7L110.61 19.6199L108.95 23.2999H110.65L115.13 12.9999H113.33ZM98.6403 19.9999H100.27V9.06993H98.6403V19.9999Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4297 7.52998C10.1397 7.83998 9.96973 8.31998 9.96973 8.92998V31.05C9.96973 31.67 10.1397 32.15 10.4297 32.45L10.4997 32.52L22.8897 20.13V19.98V19.83L10.5097 7.45998L10.4297 7.52998Z",
    fill: "url(#paint0_linear_564_649)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0196 24.27L22.8896 20.14V19.99V19.84L27.0196 15.71L27.1196 15.77L32.0096 18.55C33.4096 19.34 33.4096 20.64 32.0096 21.44L27.1196 24.22L27.0196 24.27Z",
    fill: "url(#paint1_linear_564_649)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1197 24.22L22.8997 20L10.4297 32.46C10.8897 32.95 11.6497 33.01 12.5097 32.52L27.1197 24.22Z",
    fill: "url(#paint2_linear_564_649)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1197 15.77L12.5097 7.46998C11.6497 6.97998 10.8897 7.03998 10.4297 7.52998L22.8897 19.99L27.1197 15.77Z",
    fill: "url(#paint3_linear_564_649)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M27.0295 24.13L12.5095 32.37C11.6995 32.83 10.9695 32.8 10.5095 32.38L10.4395 32.45L10.5095 32.52C10.9795 32.94 11.6995 32.97 12.5095 32.51L27.1195 24.21L27.0295 24.13Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M10.4297 32.31C10.1397 32 9.96973 31.52 9.96973 30.91V31.06C9.96973 31.68 10.1397 32.16 10.4297 32.46L10.4997 32.39L10.4297 32.31Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M32.0095 21.29L27.0195 24.12L27.1095 24.21L31.9995 21.43C32.6995 21.03 33.0495 20.51 33.0495 19.99C32.9995 20.47 32.6495 20.93 32.0095 21.29Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M12.5097 7.61998L32.0097 18.7C32.6397 19.06 32.9997 19.52 33.0597 20C33.0597 19.48 32.7097 18.95 32.0097 18.56L12.5097 7.46998C11.1097 6.67998 9.96973 7.33998 9.96973 8.93998V9.08998C9.96973 7.47998 11.1097 6.81998 12.5097 7.61998Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M41.26 26.7899L41.09 28.9499H40.63L40.46 26.7899H41.26Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5703 29.7199C47.5703 30.7099 47.3003 31.4599 46.7603 31.9899C46.2303 32.5099 45.4503 32.7699 44.4503 32.7699H42.7803V26.7899H44.6203C45.5503 26.7899 46.2703 27.0499 46.7903 27.5599C47.3103 28.0699 47.5703 28.7899 47.5703 29.7199ZM46.7803 29.7499C46.7803 28.9899 46.5903 28.4099 46.2203 28.0199C45.8403 27.6299 45.2803 27.4299 44.5203 27.4299H43.5403V32.1199H44.3503C45.9703 32.1199 46.7803 31.3299 46.7803 29.7499Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0398 27.3599C50.4298 27.3599 49.7898 27.4699 49.1298 27.6999V27.0099C49.4698 26.8899 49.7898 26.8099 50.0898 26.7599C50.3898 26.7099 50.7098 26.6899 51.0598 26.6899C51.9698 26.6899 52.6698 26.9599 53.1798 27.5099C53.6798 28.0499 53.9398 28.8099 53.9398 29.7899C53.9398 30.7399 53.6998 31.4899 53.2298 32.0399C52.7598 32.5799 52.0998 32.8599 51.2398 32.8599C50.4198 32.8599 49.7998 32.5999 49.3798 32.0899C48.9598 31.5799 48.7598 30.8099 48.7598 29.7899V29.4999H53.1398C53.0898 28.7899 52.8898 28.2599 52.5398 27.8999C52.1798 27.5399 51.6798 27.3599 51.0398 27.3599ZM51.2298 32.1899C51.7898 32.1899 52.2298 32.0099 52.5698 31.6599C52.8998 31.2999 53.0898 30.7999 53.1298 30.1599H49.5498C49.5498 30.8599 49.6898 31.3699 49.9598 31.6999C50.2398 32.0299 50.6598 32.1899 51.2298 32.1899Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M59.74 27.3599C59.13 27.3599 58.49 27.4699 57.83 27.6999V27.0099C58.17 26.8899 58.49 26.8099 58.79 26.7599C59.09 26.7099 59.41 26.6899 59.76 26.6899C60.67 26.6899 61.37 26.9599 61.88 27.5099C62.38 28.0499 62.64 28.8099 62.64 29.7899C62.64 30.7399 62.4 31.4899 61.93 32.0399C61.46 32.5799 60.8 32.8599 59.94 32.8599C59.12 32.8599 58.5 32.5999 58.08 32.0899C57.66 31.5799 57.46 30.8099 57.46 29.7899V29.4999H61.84C61.79 28.7899 61.59 28.2599 61.24 27.8999C60.88 27.5399 60.38 27.3599 59.74 27.3599ZM59.93 32.1899C60.49 32.1899 60.93 32.0099 61.27 31.6599C61.6 31.2999 61.79 30.7999 61.83 30.1599H58.25C58.25 30.8599 58.39 31.3699 58.66 31.6999C58.94 32.0299 59.36 32.1899 59.93 32.1899Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1299 32.7699V26.7899H64.8799V32.0999H67.4899V32.7699H64.1299Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4797 29.7199C73.4797 30.7099 73.2097 31.4599 72.6697 31.9899C72.1297 32.5099 71.3597 32.7699 70.3497 32.7699H68.6797V26.7899H70.5197C71.4497 26.7899 72.1697 27.0499 72.6897 27.5599C73.2197 28.0699 73.4797 28.7899 73.4797 29.7199ZM72.6797 29.7499C72.6797 28.9899 72.4897 28.4099 72.1197 28.0199C71.7397 27.6299 71.1797 27.4299 70.4197 27.4299H69.4397V32.1199H70.2497C71.8697 32.1199 72.6797 31.3299 72.6797 29.7499Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9402 27.3599C76.3302 27.3599 75.6902 27.4699 75.0302 27.6999V27.0099C75.3702 26.8899 75.6902 26.8099 75.9902 26.7599C76.2902 26.7099 76.6102 26.6899 76.9602 26.6899C77.8702 26.6899 78.5702 26.9599 79.0802 27.5099C79.5802 28.0499 79.8402 28.8099 79.8402 29.7899C79.8402 30.7399 79.6002 31.4899 79.1302 32.0399C78.6602 32.5799 78.0002 32.8599 77.1402 32.8599C76.3202 32.8599 75.7002 32.5999 75.2802 32.0899C74.8602 31.5799 74.6602 30.8099 74.6602 29.7899V29.4999H79.0402C78.9902 28.7899 78.7902 28.2599 78.4402 27.8999C78.0902 27.5399 77.5902 27.3599 76.9402 27.3599ZM77.1302 32.1899C77.6902 32.1899 78.1302 32.0099 78.4702 31.6599C78.8002 31.2999 78.9902 30.7999 79.0302 30.1599H75.4502C75.4502 30.8599 75.5902 31.3699 75.8602 31.6999C76.1402 32.0299 76.5602 32.1899 77.1302 32.1899Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0197 32.7699H83.6797V26.7899H87.0197V27.4499H84.4297V29.3199H86.8697V29.9699H84.4297V32.1099H87.0197V32.7699Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2902 29.7199C93.2902 30.7099 93.0202 31.4599 92.4802 31.9899C91.9402 32.5099 91.1702 32.7699 90.1602 32.7699H88.4902V26.7899H90.3302C91.2602 26.7899 91.9802 27.0499 92.5002 27.5599C93.0402 28.0699 93.2902 28.7899 93.2902 29.7199ZM92.5002 29.7499C92.5002 28.9899 92.3102 28.4099 91.9402 28.0199C91.5602 27.6299 91.0002 27.4299 90.2402 27.4299H89.2602V32.1199H90.0702C91.6902 32.1199 92.5002 31.3299 92.5002 29.7499Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4696 32.7699H94.3096V32.3399L95.0096 32.1799V27.3899L94.3096 27.2199V26.7899H96.4696V27.2199L95.7696 27.3899V32.1799L96.4696 32.3399V32.7699Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M102.54 32.7699H101.66L98.4598 27.7999H98.4298L98.4498 28.1299C98.4798 28.6299 98.4998 29.0599 98.4998 29.4199V32.7699H97.7998V26.7899H98.6698L98.8498 27.0799L100.81 30.1199L101.85 31.7399H101.88C101.87 31.6699 101.86 31.4399 101.85 31.0399C101.83 30.6399 101.83 30.3499 101.83 30.1699V26.7899H102.53V32.7699H102.54Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_564_649",
    x1: 21.7962,
    y1: 8.70508,
    x2: 5.01383,
    y2: 25.4875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00657445,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_564_649",
    x1: 33.8307,
    y1: 19.9969,
    x2: 9.63385,
    y2: 19.9969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_564_649",
    x1: 24.8234,
    y1: 22.2915,
    x2: 2.06509,
    y2: 45.0498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_564_649",
    x1: 7.29379,
    y1: 0.171578,
    x2: 17.4563,
    y2: 10.3341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/google-play.db5546a47da37b2d2dba5f09b4944a91.svg";
export { ForwardRef as ReactComponent };